"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaConstructionParseRequestToJSON = exports.RosettaConstructionParseRequestFromJSONTyped = exports.RosettaConstructionParseRequestFromJSON = void 0;
const _1 = require("./");
function RosettaConstructionParseRequestFromJSON(json) {
    return RosettaConstructionParseRequestFromJSONTyped(json, false);
}
exports.RosettaConstructionParseRequestFromJSON = RosettaConstructionParseRequestFromJSON;
function RosettaConstructionParseRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'network_identifier': _1.NetworkIdentifierFromJSON(json['network_identifier']),
        'signed': json['signed'],
        'transaction': json['transaction'],
    };
}
exports.RosettaConstructionParseRequestFromJSONTyped = RosettaConstructionParseRequestFromJSONTyped;
function RosettaConstructionParseRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'network_identifier': _1.NetworkIdentifierToJSON(value.network_identifier),
        'signed': value.signed,
        'transaction': value.transaction,
    };
}
exports.RosettaConstructionParseRequestToJSON = RosettaConstructionParseRequestToJSON;
//# sourceMappingURL=RosettaConstructionParseRequest.js.map